import React from 'react';
import { Link } from 'react-router-dom';
import { skillGroups } from '../data/portfolio';
import '../styles/expertise.css';

export default function ExpertiseSection() {
  return <section id="skills" className="portfolio-container expertise-section" aria-labelledby="skills-title">
    <header className="expertise-header">
      <p className="section-kicker">Skills</p>
      <h1 id="skills-title">What I build with.</h1>
      <p>A focused toolkit shaped by real engineering problems.</p>
    </header>
    <ol className="expertise-rows">
      {skillGroups.map((group, index) => <li className="expertise-row" key={group.title}>
        <span className="expertise-number" aria-hidden="true">{String(index + 1).padStart(2, '0')}</span>
        <h2>{group.title}</h2>
        <div className="expertise-detail">
          <p>{group.description}</p>
          <ul className="expertise-technologies" aria-label={`${group.title} technologies`}>{group.items.map(item => <li key={item}>{item}</li>)}</ul>
          <ul className="expertise-technologies expertise-capabilities" aria-label={`${group.title} capabilities`}>{group.capabilities.map(capability => <li key={capability}>{capability}</li>)}</ul>
          {group.link && <Link className="expertise-work-link" to={group.link.to}>{group.link.label}<span aria-hidden="true"> ↗</span></Link>}
        </div>
      </li>)}
    </ol>
  </section>;
}
